import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from '../app/views/Home/Home';
import Model from '../app/views/Model/Model';
import Talent from '../app/views/Talent/Talent';
import Casting from '../app/views/Casting/Casting';
import Fantasy from '../app/views/Fantasy/Fantasy';
import FantasyCreate from '../app/views/FantasyCreate/FantasyCreate';
import Contact from '../app/views/Contact/Contact';
import Account from '../app/views/Account/Account';
import Error from '../app/views/Error/Error';

import ScrollToTop from '../app/components/ScrollToTop/ScrollToTop';

const AppRoutes = () => {

    return (
        <div className="">
            <Router>
                <Routes>
                    <Route element={<ScrollToTop />}>
                        <Route exact path={'/'} element={<Home />} />
                        <Route exact path={'/models/:city/:slug'} element={<Model />} />
                        <Route exact path={'/talent'} element={<Talent />} />
                        <Route exact path={'/talent/:city'} element={<Talent />} />
                        <Route exact path={'/casting'} element={<Casting />} />
                        <Route exact path={'/contact'} element={<Contact />} />
                        <Route exact path={'/fantasy/create'} element={<FantasyCreate />} />
                        <Route exact path={'/fantasy'} element={<Fantasy />} />
                        <Route exact path={'/account'} element={<Account />} />
                        <Route exact path={'/account/:section'} element={<Account />} />
                        <Route exact path={'/account/:section/:id'} element={<Account />} />
                        <Route exact path={'*'} element={<Error />} />
                    </Route>
                </Routes>
            </Router>
        </div>
    )
}

export default AppRoutes;